import cn from 'classnames';

import { FormMessage, MessageType } from 'components/FormComponents/FormMessage/FormMessage';
import ScaleMotion from 'components/Motion/ScaleMotion';

import { IconComponent } from './../../Icon/IconComponent';
import StatusPill from './../../Pills/StatusPills';
import styles from './DataCard.module.scss';

export const DataCard = ({
  icon,
  iconSize = 'large',
  className,
  title,
  description,
  disabled = false,
  background = 'white',
  onClick = () => {},
  link = null,
  keyProp = 'data-card',
  showStatusBorder = false,
  iconType = 'default',
  displayStatus = true,
  gap = 'large',
  caption,
  large = false,
  useExpirationDate = false,
  expirationDate = null,
  message = null,
  status = {
    text: 'Pending',
    status: 'neutral',
  },
}) => {
  return (
    <ScaleMotion keyProp={keyProp} className="d-flex flex-column u-gap-large" disabled={disabled}>
      <div
        onClick={link ? () => window.open(link, '_blank') : onClick}
        className={cn(styles.root, `d-flex flex-column u-gap-${gap}`, {
          [styles['secondary-card']]: background === 'secondary',
          [styles.disabled]: disabled,
          [`u-border-${status.status}`]: showStatusBorder,
          [className]: className,
        })}
        data-testid={`section-card-${keyProp}`}
        data-status={status.status}>
        {icon && (
          <div className={styles.iconWrapper}>
            <IconComponent icon={icon} type={iconType} className={styles.icon} size={iconSize} />
          </div>
        )}
        <div className={cn(styles.contentWrapper)}>
          <div className={styles.header}>
            {displayStatus && (
              <StatusPill
                text={status.text}
                status={status.status}
                className={cn(styles.status, 'px-4')}
              />
            )}
            {useExpirationDate && expirationDate && (
              <span className="secondary-text u-font-size-small u-font-weight-400 u-margin-left--small">
                <StatusPill
                  text={`Complete by ${expirationDate}`}
                  status="warning"
                  className={cn(styles.status, 'px-4')}
                />
              </span>
            )}
          </div>
          <div className={styles.content}>
            <div className="d-flex flex-column u-gap-small">
              {caption && (
                <span className="tertiary-text u-font-size-small u-font-weight-500">{caption}</span>
              )}
              <span
                className={cn('primary-text text-3xl font-medium capitalize', {
                  'text-5xl': large,
                })}>
                {title}
              </span>
            </div>
            {description && (
              <span className="secondary-text text-xl font-regular">{description}</span>
            )}
            {message && (
              <div className="u-margin-top--small">
                <FormMessage
                  message={message}
                  type={MessageType.Info}
                  closeable={false}
                  noMargin
                  small
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </ScaleMotion>
  );
};
